<template>
  <cyma-layout>
    <router-view />
  </cyma-layout>
</template>

<script>
import CymaLayout from '../layouts/CymaLayout'

export default {
  components: { CymaLayout }
}
</script>
